import debouncePromise from 'debounce-promise';

import { useDefaultCatch } from '@atlassian/eoc-catch';
import { errorToastProps } from '@atlassian/eoc-common';
import { isNetworkError, useFlags } from '@atlassian/eoc-global-context';

import { type AutoCompleteEndpoint, type AutoCompleteItem } from '../../common/types';

export const useAutoCompleteOptions = (endpoints: AutoCompleteEndpoint[]) => {
	const { showFlag } = useFlags();
	const defaultCatch = useDefaultCatch();

	return debouncePromise((inputValue: string): Promise<AutoCompleteItem[] | void> => {
		return Promise.all(
			endpoints.map((endpoint) => {
				return endpoint({
					keyword: inputValue,
				});
			}),
		)
			.then((response) =>
				response
					.flatMap((r) => r.values)
					.map((r) => ({
						label: r.name,
						value: r.id,
						...r,
					})),
			)
			.catch((error) => {
				// If we cancel one of the request we shouldn't display toast
				if (isNetworkError(error) && error.cause instanceof DOMException) {
					return;
				}

				throw error;
			})
			.catch(
				defaultCatch({
					id: 'useAutoCompleteOptions',
					httpErrorHandler: (error) => {
						showFlag({
							...errorToastProps(),
							title: error.message,
							isAutoDismiss: true,
						});
					},
				}),
			);
	}, 300);
};
